import { Divider, Text } from '@ui';
import { FormattedMessage, useIntl } from 'react-intl';
import { connect } from 'react-redux';

import iwocaPayMessages from './HelpModal.iwocaPay.messages';
import iwocaMessages from './HelpModal.messages';
import { isIwocaPayCustomer as isIwocaPayCustomerSelector } from '../../../api/iwocaPaySelector';
import { getCountry } from '../../../iwIntlProvider/CountryProvider';
import { CLOSE_MODAL } from '../../../iwModals/Modals.actions';
import { ChatBubblesSVG } from '../../../svgComponents/chatBubblesSVG/index';
import { EnvelopeSVG } from '../../../svgComponents/envelopeSVG';
import { FaqSVG } from '../../../svgComponents/faqSVG';
import { HelpSVG } from '../../../svgComponents/helpSVG';
import { PhoneSVG } from '../../../svgComponents/phoneSVG';

const mapStateToProps = (state) => ({
    hasIwocaPayLoan: isIwocaPayCustomerSelector(state)
});

const mapDispatchToProps = (dispatch) => ({
    closeModal: () => {
        dispatch({
            type: CLOSE_MODAL
        });
    }
});
// eslint-disable-next-line import/no-default-export
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(({ closeModal, hasIwocaPayLoan }) => {
    const intl = useIntl();
    const messages = hasIwocaPayLoan ? iwocaPayMessages : iwocaMessages;

    return (
        <div className="p-l">
            <div
                className="mb-xl flex items-center justify-center"
                data-testid="help-modal"
            >
                <Text className="text-2xl font-med">
                    <FormattedMessage {...messages.title} />
                </Text>
                <HelpSVG />
            </div>
            <div>
                <div className="space-y-xl">
                    <div className="flex flex-col items-center justify-evenly space-y-xl min-sm:flex-row min-sm:space-y-0">
                        <div className="flex items-center">
                            <PhoneSVG className="mr-s fill-core-65" />
                            <div>
                                <FormattedMessage {...messages.phoneCaption} />{' '}
                                <a
                                    href={`tel:${intl.formatMessage(
                                        messages.callPhoneNumber
                                    )}`}
                                    className="text-primary-40 underline"
                                >
                                    <FormattedMessage
                                        {...messages.displayPhoneNumber}
                                    />
                                </a>
                            </div>
                        </div>
                        <div className="flex items-center">
                            <ChatBubblesSVG className="mr-s fill-core-65" />
                            <div>
                                <FormattedMessage {...messages.chatCaption} />{' '}
                                <button
                                    onClick={closeModal}
                                    className="ChatSupportButton border-none bg-transparent text-primary-40 underline"
                                >
                                    <FormattedMessage {...messages.chat} />
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="text-center">
                        <FormattedMessage
                            {...messages.availabilityMessageLineOne}
                        />{' '}
                        <FormattedMessage
                            {...messages.availabilityMessageLineTwo}
                        />
                        {getCountry() === 'UK' && (
                            <Text className="text-s">
                                (excluding bank holidays)
                            </Text>
                        )}
                    </div>
                </div>
                <Divider className="my-xl" />
                <div className="space-y-m">
                    <div className="flex items-center">
                        <EnvelopeSVG className="mr-s fill-core-65" />
                        <div>
                            <FormattedMessage {...messages.emailCaption} />{' '}
                            <a
                                href={`mailto:${intl.formatMessage(
                                    messages.email
                                )}`}
                                className="text-primary-40 underline"
                            >
                                <FormattedMessage {...messages.email} />
                            </a>
                        </div>
                    </div>

                    <div className="flex items-center">
                        <FaqSVG className="mr-s shrink-0 fill-core-65" />
                        <div>
                            <FormattedMessage {...messages.faqCaption} />{' '}
                            <a
                                href="/faq/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-primary-40 underline"
                            >
                                <FormattedMessage {...messages.faq} />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
});
